<div class="video-player" [ngClass]="{ '!w-max': !isFullWidth() }">
  <!-- view section -->
  <video
    class="video-player__view"
    [ngClass]="{ '!w-auto': !isFullWidth() }"
    [src]="videoPreviewSrc()"
    (loadedmetadata)="videoDuration($event)"
    (durationchange)="videoDuration($event)"
    (timeupdate)="videoCurrentTime($event)"
    (mouseenter)="showControllers()"
    (click)="
      isVideoPlaying ? pauseVideo(videoElement) : playVideo(videoElement)
    "
    #videoElement>
    <source [src]="videoPreviewSrc()" type="video/mp4" #videoSourceElement />
  </video>

  <!-- controllers section -->

  <div
    class="video-player__controllers"
    [ngClass]="{ 'opacity-0 !hidden': isVideoPlaying && hiddenPlayBtn }">
    <!-- video progress bar section -->
    <div class="video-player__progress-bar-container">
      <!-- slider input -->
      <div class="progress-bar" #progressBox>
        <input
          class="progress-bar__thumb progress-bar__thumb--left"
          type="range"
          [min]="0"
          [max]="videoDurationInSeconds"
          [value]="videoCurrentTimeInSeconds"
          (input)="seekVideo($event)"
          #progressInput />

        <div
          class="progress-bar__slider"
          (click)="handleVideoProgressBarClick($event, progressBox)">
          <div class="slider-track"></div>
          <div #progressRange class="slider-range"></div>
        </div>
      </div>
    </div>

    <!-- video player buttons -->
    <div class="video-player__buttons">
      <div class="video-player__main-buttons">
        <!-- play video icon -->
        <div>
          @if (!isVideoPlaying) {
            <button (click)="playVideo(videoElement)">
              <i class="btn-icon iconsax" icon-name="play"></i>
            </button>
          } @else {
            <!-- pause video icon -->
            <button (click)="pauseVideo(videoElement)">
              <i class="btn-icon iconsax" icon-name="pause"></i>
            </button>
          }
        </div>

        <!-- Prev 15 seconds and Next 15 seconds buttons -->
        <div>
          <button (click)="prevSeconds()">
            <i class="iconsax" icon-name="media-backward-15s"></i>
          </button>

          <button (click)="nextSeconds()">
            <i class="iconsax" icon-name="media-forward-15s"></i>
          </button>
        </div>

        <p>
          {{ formatTime(videoCurrentTimeInSeconds) }} /
          {{ formatTime(videoDurationInSeconds) }}
        </p>
      </div>

      <div class="video-player__options">
        <button (click)="toggleSpeed()">
          <i class="iconsax" icon-name="stopwatch-play"></i>
          {{ currentSpeed }}x
        </button>

        <!-- sound settings -->
        <div class="video-player__sound-controller">
          <div class="video-player__mute-button">
            <button (click)="toggleMute()">
              @switch (true) {
                @case (currentVolume === 0) {
                  <i class="iconsax" icon-name="volume-x"></i>
                }
                @case (currentVolume < 0.3) {
                  <i class="iconsax" icon-name="volume-mute"></i>
                }
                @case (currentVolume < 0.65) {
                  <i class="iconsax" icon-name="volume-low"></i>
                }
                @default {
                  <i class="iconsax" icon-name="volume-high"></i>
                }
              }
            </button>
          </div>

          <!-- video progress bar section -->
          <div class="video-player__volume-input">
            <!-- slider input -->
            <div class="volume-bar" #volumeBox>
              <input
                class="volume-bar__thumb volume-bar__thumb--left"
                type="range"
                min="0"
                max="1"
                step="0.01"
                [value]="currentVolume"
                (input)="changeVolume($event)" />

              <div
                class="volume-bar__slider"
                (click)="handleSoundProgressBarClick($event, volumeBox)">
                <div class="slider-track"></div>
                <div #volumeRange class="slider-range"></div>
              </div>
            </div>
          </div>
        </div>

        <button (click)="toggleFullScreen()">
          <i class="iconsax" icon-name="maximize-1"></i>
        </button>
        <!-- Download button -->
        <button>
          <a [href]="videoPreviewSrc()" download="video.mp4">
            <i class="iconsax" icon-name="download-1"></i>
          </a>
        </button>
      </div>
    </div>
  </div>
</div>
